// import React from "react";
// import TeamMemberCard from "./TeamMemberCard";
// import teamProfile from "../../team-profile";

// const TeamProfile = () => {
//   return (
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//       {teamProfile.map((member, index) => (
//         <TeamMemberCard
//           key={index}
//           member={member}
//         />
//       ))}
//     </div>
//   );
// };

// export default TeamProfile;

"use client";
import { useParams, Link } from "react-router-dom";
import Footer from "../footer/footer.component";
import teamProfile from "../../team-profile";
import TeamMemberSkills from "./team-member-skills";

const StatsCard = ({ value, label }) => (
  <div className="bg-white rounded-lg p-4 shadow-sm">
    <h3 className="text-3xl font-bold text-[#2F1893] mb-2">{value} +</h3>
    <p className="text-[#080808] text-sm">{label}</p>
  </div>
);

const ProfileHeader = ({ memberDetails }) => {
  const backgroundImage = memberDetails.image
    ? require(`../../assets/img/team/${memberDetails.image}`)
    : "/placeholder.svg";

  return (
    <section
      className="relative bg-cover bg-top sm:bg-center bg-no-repeat py-6 text-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#2F1893]/90 to-[#000000]/90"></div>

      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="flex flex-col lg:flex-row lg:justify-around lg:items-center gap-8">
          {/* Left Content */}
          <div className="space-y-8 text-left max-w-lg mx-auto lg:mx-0">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 text-white">
              {memberDetails.name}
            </h1>
            <p className="text-lg sm:text-xl text-white mb-4">
              • {memberDetails.role}
            </p>
            <p className="text-white leading-relaxed whitespace-pre-line">
              {memberDetails.intro}
            </p>

            {/* Stats Cards */}
            <div className="grid grid-cols-2 gap-4 max-w-xs sm:max-w-md">
              <StatsCard
                value={memberDetails.yearsExperience}
                label="Years Experience"
              />
              <StatsCard
                value={memberDetails.projectsCompleted}
                label="Projects Completed"
              />
            </div>
          </div>

          {/* Orange Bars (only absolute on lg and up) */}
          <div className="hidden lg:flex absolute z-10 top-28 left-2/3 transform -translate-x-1/2 flex-col items-center space-y-4">
            <span className="block w-40 h-[3px] bg-orange-500"></span>
            <span className="block w-40 h-[3px] bg-orange-500"></span>
            <span className="block w-40 h-[3px] bg-orange-500"></span>
          </div>

          {/* Right Image */}
          <div className="relative mx-auto lg:mx-0">
            {/* <div className="relative w-[250px] sm:w-[300px] lg:w-[400px] rounded-2xl p-1">
              <div className="aspect-4/5">
                <img
                  src={
                    memberDetails.image
                      ? require(`../../assets/img/team/${memberDetails.image}`)
                      : "/placeholder.svg"
                  }
                  alt={memberDetails.name}
                  className="w-full h-full object-cover rounded-tr-[30px] lg:rounded-tr-[50px] border-orange-500 border-t-2 border-r-2 border-b-2 rounded-bl-[30px] lg:rounded-bl-[50px]"
                  onError={(e) => {
                    e.target.src = "/placeholder.svg";
                  }}
                />
              </div>
            </div> */}
            <div className="w-[300px] rounded-md relative">
              <div className="aspect-[4/5] w-full relative overflow-hidden">
                <img
                  src={
                    memberDetails.image
                      ? require(`../../assets/img/team/${memberDetails.image}`)
                      : "/placeholder.svg"
                  }
                  alt="team member"
                  className="w-full h-full object-cover  rounded-tr-[30px] lg:rounded-tr-[50px] border-orange-500 border-t-2 border-r-2 border-b-2 rounded-bl-[30px] lg:rounded-bl-[50px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ProfileBio = ({ memberDetails }) => (
  <section className="bg-gray-50 py-16">
    <div className="container mx-auto px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold underline decoration-[#FF7200] text-[#000000] mb-8 text-center">
          Meet {memberDetails.name.split(" ")[0]}
        </h2>
        <div className=" mx-auto whitespace-pre-line text-[#080808] leading-relaxed">
          <p>{memberDetails.bio}</p>

          <div></div>

          <p> {memberDetails.bio2} </p>
        </div>
      </div>
    </div>
  </section>
);

const TeamProfile = () => {
  const { memberName } = useParams();
  // const memberDetails = teamProfile.find((m) => m.id.toString() === memberName);
  const memberDetails = teamProfile.find(
    (m) => m.name.toLowerCase().replace(/\s+/g, "-") === memberName
  );

  if (!memberDetails) {
    return (
      <div className="container font-Outfit mx-auto p-6 text-center">
        <div className="max-w-md mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Member not found
          </h2>
          <p className="text-gray-600 mb-6">
            The team member you're looking for doesn't exist.
          </p>
          <Link
            to="/team"
            className="inline-flex items-center px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
          >
            ← Back to Team
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-6 py-6">
        <Link
          to="/team"
          className="inline-flex items-center px-4 py-2 text-purple-600 hover:text-purple-800 transition-colors"
        >
          ← Back to Team
        </Link>
      </div>

      <ProfileHeader memberDetails={memberDetails} />
      <ProfileBio memberDetails={memberDetails} />

      <TeamMemberSkills memberDetails={memberDetails} />

      <Footer />
    </div>
  );
};

export default TeamProfile;
